/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoredObjectType,
    ReadOnlyMonitoredObjectTypeFromJSON,
    ReadOnlyMonitoredObjectTypeFromJSONTyped,
    ReadOnlyMonitoredObjectTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20028
 */
export interface InlineResponse20028 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20028
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20028
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20028
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoredObjectType>}
     * @memberof InlineResponse20028
     */
    results: Array<ReadOnlyMonitoredObjectType>;
}

export function InlineResponse20028FromJSON(json: any): InlineResponse20028 {
    return InlineResponse20028FromJSONTyped(json, false);
}

export function InlineResponse20028FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20028 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoredObjectTypeFromJSON)),
    };
}

export function InlineResponse20028ToJSON(value?: InlineResponse20028 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoredObjectTypeToJSON)),
    };
}


